import type { ComponentProps } from 'react';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import type { ReadonlyProp } from 'src/redux/types';

import { BlockEmptyView } from '../block-empty-view';

interface Props extends ReadonlyProp, Pick<ComponentProps<'div'>, 'onClick'> {
  defaultOpenPanel: boolean;
  text?: string;
}
export const EmptyVideo = (props: Props) => {
  const { t } = useAppTranslation();
  return (
    <BlockEmptyView
      defaultOpenPanel={props.defaultOpenPanel}
      readonly={props.readonly}
      iconProp={{
        name: 'IcUploadVideo',
        size: 'normal',
      }}
      text={props.text ?? t('editor.video.add_video')}
      onClick={props.onClick}
      className={props.readonly ? 'cursor-default' : 'cursor-pointer'}
    />
  );
};
